// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fqVU","icon":"styles_icon__3ow50"};